export default "__VITE_ASSET__DVlL5Gjw__"